import LocalStorageService from './LocalStorageService';

export default class AccordiumService {
  /**
   * avoid browser error, let it return 401 if userToken undefined.
   * @returns {*}
   */
  static retrieveToken() {
    const userToken = LocalStorageService.getCognitoItem('accessToken');
    if (userToken !== undefined) return userToken;
    return '';
  }

  static getTokenString() {
    return `Bearer ${this.retrieveToken()}`;
  }

  static getHeaders() {
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.getTokenString(),
      },
    };
  }

  static getMultipartHeaders() {
    return {
      headers: {
        'Content-Type': 'multipart/common-data',
        Authorization: this.getTokenString(),
      },
    };
  }

  static getMultipartHeadersApprover() {
    return {
      headers: {
        'Content-Type': 'multipart/common-data',
      },
    };
  }

  static getVideoHeaders(type) {
    return {
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        const persentComlited = Math.round((progress.loaded * 100) / progress.total);
        console.log(persentComlited);
      },
      headers: {
        'Content-Type': `video/${type}`,
      },
    };
  }

  static getApproverHeaders() {
    return {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }
}
